import { AccountCreateModule } from '@account-create';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@shared';

import { COMPONENTS } from './components';
import { CONTAINERS } from './containers';
import { DIRECTIVES } from './directives';
import { TrialAccountsStateModule } from './state/trial-accounts-state.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    TrialAccountsStateModule,
    AccountCreateModule,
    NgbModule,
  ],
  declarations: [...COMPONENTS, ...CONTAINERS, ...DIRECTIVES],
})
export class TrialAccountsModule {}
